/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tracking_Playback_End_Before_StartInputs */

const vi_tracking_playback_end_before_start = /** @type {(inputs: Tracking_Playback_End_Before_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thời gian kết thúc phải sau thời gian bắt đầu`)
};

/**

* @param {Tracking_Playback_End_Before_StartInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tracking_playback_end_before_start = /** @type {((inputs?: Tracking_Playback_End_Before_StartInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tracking_Playback_End_Before_StartInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tracking_playback_end_before_start(inputs)
});